module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_07-94a32661cfbb6d8fda287b6681360dc6.png";